import actionTypes from '../actionTypes';

export const checkToken = (error) => {
  if (error) {
    if (error.detail && error.detail === 'Invalid token.') {
      return { type: actionTypes.INVALID_TOKEN };
    }
  }

  return { type: 'OK' };
};



// WEBPACK FOOTER //
// src/redux/sagas/check.js